import type { ItemV2 } from '@/lib/api/types/items';

export function systemProgressToProgress(
  itemId: number,
  progressMap: Map<number, number>,
): number | null {
  const value = progressMap.get(itemId);
  return value !== undefined ? value : null;
}

export function progressFieldIdToProgress(fieldId: number | null, item: ItemV2): number | null {
  if (!fieldId) return null;
  const customFieldValue = item.customFieldValues?.[fieldId];
  if (
    customFieldValue == null ||
    Array.isArray(customFieldValue) ||
    Number.isNaN(Number(customFieldValue)) ||
    typeof customFieldValue === 'boolean'
  ) {
    return null;
  }
  const parsed = Number(customFieldValue);
  if (Number.isNaN(parsed)) return null;
  const normalized = parsed > 1 ? parsed / 100 : parsed;
  return Math.min(1, Math.max(0, normalized));
}
